import React from 'react';
import PropTypes from 'prop-types';

import { Tooltip } from '@material-ui/core';
import { validateCodeTitle } from '../../../../helpers/validateCodes';
import {
  Column,
  ElevatedForm,
  SubmitButton,
  CancelButton,
  TextFieldWithError
} from '../../../Forms/FormComponents';
import { FormTop, FormBottom } from '../../SharedSC/FormSC';

const TopicForm = ({
  code,
  topic,
  buttonText,
  showValidationErrors,
  handleChange,
  onSubmit,
  closeForm
}) => (
  <ElevatedForm>
    <FormTop>
      <Column size="20%">
        <Tooltip title="Cannot edit generated topic code">
          <TextFieldWithError
            id="topicCode"
            name="code"
            value={code}
            onChange={event => handleChange(event)}
            margin="normal"
            InputLabelProps={{ shrink: true }}
            label="Topic Code*"
            placeholder=""
            variant="outlined"
            disabled
            validate={undefined}
            showValidationErrors={false}
            paddingRight="1rem"
          />
        </Tooltip>
      </Column>
      <Column size="80%">
        <TextFieldWithError
          id="topicTitle"
          name="title"
          value={topic.title}
          onChange={event => handleChange(event)}
          margin="normal"
          InputLabelProps={{ shrink: true }}
          label="Topic Title*"
          placeholder=""
          variant="outlined"
          validate={validateCodeTitle}
          showValidationErrors={showValidationErrors}
        />
      </Column>
    </FormTop>
    <FormBottom>
      <CancelButton onClick={closeForm} noHoverBg>
        Cancel
      </CancelButton>
      <SubmitButton onClick={onSubmit}>{buttonText}</SubmitButton>
    </FormBottom>
  </ElevatedForm>
);

TopicForm.propTypes = {
  code: PropTypes.string,
  buttonText: PropTypes.string,
  topic: PropTypes.object,
  showValidationErrors: PropTypes.bool,
  handleChange: PropTypes.func,
  onSubmit: PropTypes.func,
  closeForm: PropTypes.func
};
TopicForm.defaultProps = {
  code: '',
  buttonText: 'Create',
  topic: {},
  showValidationErrors: false,
  handleChange: undefined,
  closeForm: undefined,
  onSubmit: undefined
};

export default TopicForm;
